// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8aef060f","952":"e1e4fe97"}[chunkId] + ".chunk.js";
};